export default __webpack_public_path__ + "static/slack-8dc0c38e758b7c394f61aa02880a6ded.svg";